import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initNativePlatform } from './platform'
import { tokenManager, hydrateNativeTokenCache } from './api/client'
import { installStaleChunkReload } from './lib/staleChunk'
import { captureSignupTouch } from './lib/signupTouch'

async function bootstrap() {
  installStaleChunkReload()
  captureSignupTouch()

  // Native tokens live in the OS Keychain/Keystore, read asynchronously.
  // A no-op on web. Must resolve before anything below reads tokenManager,
  // so nothing renders yet.
  await hydrateNativeTokenCache()

  // Dev auto-login: seed the mock dev tokens so the login screen never
  // appears locally (backend DEBUG=true accepts mock-access-token-dev).
  // VITE_DEV_AUTO_LOGIN covers non-DEV bundles (e.g. Capacitor dev shells);
  // production builds set neither, so this is unreachable in prod.
  if (
    (import.meta.env.DEV || import.meta.env.VITE_DEV_AUTO_LOGIN === 'true') &&
    !tokenManager.hasValidToken()
  ) {
    tokenManager.setTokens('mock-access-token-dev', 'mock-refresh-token-dev')
  }

  // Initialize MSW in development when VITE_MOCK_API is true
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true') {
    const { initMocks } = await import('./mocks')
    await initMocks()
  }

  // Wire Capacitor-shell capabilities (share-target, push). No-op on web.
  initNativePlatform()

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

bootstrap()
